<div class="modal-header">
    <h4 class="modal-title">Important Notice: Corporate Forms Platform Update</h4>
    <button
        type="button"
        class="btn btn-circle btn-sm btn-ghost element-cancel"
        [attr.aria-label]="'a11y-close' | translate"
        (click)="modalRef.hide()"
    ></button>
</div>
<div class="modal-body">
    <p>This page will be retired on March 31.</p>
    <p>
        All previously available Corporate Forms templates will be available on a new Siemens Energy internal page
        hosted fully within the Siemens Energy environment, called
        <a href="https://fasb.mx.siemens-energy.cloud/oauth/v2/login" target="_blank" rel="noopener noreferrer"
            ><strong>Siemens Energy Forms and Signature Builder</strong></a
        >.
    </p>
    <p>Please update your bookmarks.</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modalRef.hide()">OK</button>
</div>
